<template>
  <div>
    <div class="confirmation-container">
      <MedalliaSurvey page="return-confirmation" />
      <h2 class="margin-top-xs" :class="showAlertMessage ? 'padding-bottom-xxs' : 'padding-bottom-s'">Return Confirmation</h2>
      <div v-if="showAlertMessage">
        <Notification :severity="returnDetails.orderReturnAlertMessage.web?.message_type?.toLowerCase()" :closable="false">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div v-html="sanitizedAlertMessage"></div>
        </Notification>
      </div>
      <div v-if="returnConfirmationStore.returnLabel.showNotification" class="return-label-notification padding-bottom-xxs">
        <Notification severity="success" :closable="false">
          We emailed your return confirmation to
          {{ returnConfirmationStore.returnLabel.emailAddress }}.
        </Notification>
      </div>
      <div v-if="!loading" class="email-section border-bottom padding-bottom-s margin-bottom-s">
        <p v-if="!returnConfirmationStore.returnLabel.showNotification" class="margin-bottom-xs">
          We emailed your return confirmation to {{ returnDetails.emailAddress }}.
        </p>
        <button v-if="showEmailLink" class="link-med" @click="onClickToSend" @keyup.enter="onClickToSend">Send to another email</button>
        <ResendEmailForm v-if="showEmailContainer" />
      </div>
      <div>
        <ReturnlessReturnSummary :return-details="returnDetails" />
      </div>
      <p class="notes small margin-top-xs grey-border padding-bottom-s margin-bottom-m">
        <span>
          *Any points or Star Money earned from this purchase will be deducted from your Star Rewards account. <br />
          If you do not have sufficient points or Star Money, we may reduce the value of your return.
        </span>
      </p>
    </div>
    <Skeleton v-if="loading" return-less />
    <ProsWrapper
      class="small-padding-top-s large-padding-top-z small-border-top large-margin-top-m hide-for-print"
      align-horizontal
      data-context="PR_ZONE_A"
    />
  </div>
</template>

<script setup>
import { computed, onUnmounted, ref } from 'vue';
import { sanitize } from '@vue-util/sanitize';
import Notification from '@nuxt-common/atomic-ui/app/components/notification/Notification.vue';

import MedalliaSurvey from '@/components/MedalliaSurvey.vue';
import ReturnlessReturnSummary from '@/components/returns/ReturnlessReturnSummary.vue';
import ProsWrapper from '@/components/ProsWrapper.vue';
import ResendEmailForm from '@/components/returns/ResendEmailForm.vue';
import Skeleton from '@/components/skeleton/ReturnConfirmation.vue';
import { useReturnConfirmationStore } from '@/stores/returns/useReturnConfirmationStore';
import { NOTIFICATION_TYPES } from '#shared/constants';

const returnConfirmationStore = useReturnConfirmationStore();
const showEmailLink = ref(true);
const showEmailContainer = ref(false);

const returnDetails = computed(() => returnConfirmationStore.returnDetails?.returnDetails ?? {});

const loading = computed(() => !returnDetails.value.rpShipments);

const showAlertMessage = computed(() => {
  const web = returnDetails.value.orderReturnAlertMessage?.web || {};
  return web.message_type && web.message && NOTIFICATION_TYPES.includes(web.message_type?.toLowerCase());
});

const sanitizedAlertMessage = computed(() => {
  return sanitize(returnDetails.value.orderReturnAlertMessage?.web?.message);
});

const onClickToSend = () => {
  showEmailContainer.value = true;
  showEmailLink.value = false;
  return !showEmailLink.value && showEmailContainer.value;
};

onUnmounted(() => {
  returnConfirmationStore.CLEAR_RETURN_CONFIRMATION();
});
</script>

<style lang="scss" scoped>
.confirmation-container {
  @include breakpoint(medium) {
    // medium-9
    max-width: 58.33333%;
  }
  @include breakpoint(large) {
    // large-7
    max-width: 41.66667%;
  }
}
</style>
